import { ChannelAnnouncementStatModel } from '../shared/models/channel-announcement-stat-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'hr-stats-and-reports-announcements',
  templateUrl: './stats-and-reports-announcements.component.html',
  styleUrls: ['./stats-and-reports-announcements.component.less'],
  standalone: false,
})
export class StatsAndReportsAnnouncementsComponent implements OnInit {
  @Input()
  public channelAnnouncementStats: ChannelAnnouncementStatModel[];

  constructor() {}

  ngOnInit() {}
}
